export enum paymentIssueTypes {
  unknown = "unknown",
  amountIncomplete = "amountIncomplete",
  amountExcess = "amountExcess",
  duplicatePayment = "duplicatePayment",
}
